// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"5a7b881b","787":"0e029a22","964":"eeb51f03"}[chunkId] + ".chunk.js";
};